








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import {
  PersonalRelationDto,
  TitleDto,
  YesNoDefaultDto,
  SortOrder
} from "@/api/ClientPortalApiClient";
@Component({})
export default class CbxYesNoDefault extends Vue {
  private types: YesNoDefaultDto[] | null = [];
  public selectedType = new YesNoDefaultDto();

  public created() {
    this.getAvailableTypes();
  }

  public typeSelected(type: YesNoDefaultDto) {
    this.$emit("yesNoSelected", type);
  }

  public setSelected(type: YesNoDefaultDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .yesNoDefault_IndexAll2(SortOrder.Natural)
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
